import React from "react";
import { pieArcLabelClasses } from "@mui/x-charts/PieChart";
import theme from "../../theme";
import Tile from "../../types/tile";
import { useSelector } from "../../store";
import { Box, CircularProgress, useMediaQuery } from "@mui/material";
import {
  ChartsAxisHighlight,
  PiePlot,
  ResponsiveChartContainer,
} from "@mui/x-charts";
import GraphData from "../../types/graphData";
import { DataTypes } from "../../types/dataType";

interface Props {
  tileModel: Tile;
  detail?: boolean;
}

const CircleTile: React.FC<Props> = (props) => {
  const { tileModel, detail } = props;

  const { tileDetailStatus } = useSelector((store) => store.tiles);

  const getColor = (item: GraphData, index: number): string => {
    switch (tileModel.dataType?.id) {
      case DataTypes.Cameras:
      case DataTypes.Operator:
        return item.name.toLowerCase() === "online"
          ? theme.palette.success.main
          : theme.palette.error.main;
      case DataTypes.Events:
        switch (index) {
          case 0:
            return theme.palette.success.main;
          case 1:
            return theme.palette.error.main;
          case 2:
            return theme.palette.primary.main;
          case 3:
            return theme.palette.secondary.main;
          case 4:
            return theme.palette.info.main;
          default:
            return theme.palette.warning.main;
        }
      case DataTypes.Readers:
        return item.name.toLowerCase() === "online" ||
          item.name.toLowerCase() === "enabled"
          ? theme.palette.success.main
          : theme.palette.error.main;
      default:
        return theme.palette.success.main;
    }
  };

  const valuesArray = tileModel.data
    ?.filter((x) => +x.count > 0)
    .map((item, index) => ({
      label: item.name,
      value: +item.count,
      color: item.background ?? getColor(item, index),
    }));

  const md = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      sx={{ width: "100%", height: "100%" }}
      justifyContent="center"
      position="absolute"
      top={{ xs: "-35px", md: "-40px", lg: "-20px" }}
      paddingX={{ xs: 0, md: "20px" }}
      paddingBottom={{
        xs: detail ? "5vw" : "10px",
        sm: detail ? "20vw" : "65px",
        md: detail ? "30vw" : "60px",
        lg: "90px",
        xl: "120px",
      }}
    >
      {!!detail &&
      tileDetailStatus === "loading" &&
      (!tileModel.data || tileModel.data.length! < 1) ? (
        <CircularProgress />
      ) : (
        <ResponsiveChartContainer
          sx={{
            "& .MuiPieArc-root": {
              stroke: "#000",
              strokeWidth: "2px",
            },
            [`& .${pieArcLabelClasses.root}`]: {
              fill: "white",
              fontSize: md ? 25 : 15,
            },
          }}
          series={[
            {
              type: "pie",
              data: valuesArray!,
              arcLabel: "value",
              highlightScope: { fade: "global", highlight: "item" },
              innerRadius: "40%",
              paddingAngle: 5,
              cornerRadius: 5,
            },
          ]}
        >
          <ChartsAxisHighlight />
          <PiePlot skipAnimation={detail} />
        </ResponsiveChartContainer>
      )}
    </Box>
  );
};

export default CircleTile;
